"use client";

import { Handshake } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { donateHero } from "@/content/home";
import { DonateGoldCta } from "@/components/donate/DonateGoldCta";
import { DonateImageBackdrop } from "@/components/donate/DonateImageBackdrop";

interface DonateSplitHeroProps {
  onCtaClick?: () => void;
}

export function DonateSplitHero({ onCtaClick }: DonateSplitHeroProps) {
  return (
    <DonateImageBackdrop
      priority
      className="donate-split-hero"
      minHeight="min-h-[min(72vh,640px)] md:min-h-[100dvh]"
    >
      <div className="relative">
        <Reveal>
          <p
            className="font-display text-4xl leading-none text-[var(--charity-gold)] md:text-5xl"
            aria-hidden
          >
            {donateHero.quoteMark}
          </p>
          <h1 className="font-display text-2xl font-bold leading-tight text-white md:text-3xl lg:text-[2rem]">
            {donateHero.headline}{" "}
            <span className="text-[var(--charity-gold)]">
              {donateHero.headlineHighlight}
            </span>{" "}
            {donateHero.headlineEnd}
          </h1>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="my-4 flex items-center gap-3" aria-hidden>
            <span className="h-px flex-1 bg-[var(--charity-gold)]/60" />
            <Handshake
              size={14}
              className="text-[var(--charity-gold)]"
            />
            <span className="h-px flex-1 bg-[var(--charity-gold)]/60" />
          </div>
          <p className="text-sm leading-relaxed text-white/90 md:text-base">
            {donateHero.subline}
          </p>
        </Reveal>

        <Reveal delay={0.14}>
          <p className="mt-3 font-display text-xl italic text-[var(--charity-gold)] md:text-2xl">
            {donateHero.thankYou}
          </p>
          <div className="mt-5">
            <DonateGoldCta label={donateHero.cta} onClick={onCtaClick} />
          </div>
        </Reveal>
      </div>
    </DonateImageBackdrop>
  );
}
